import React, {FC} from "react";
import {Typography} from "antd";
import {CalendarOutlined, EnvironmentOutlined} from "@ant-design/icons";
import {useRegistrationCopy} from "./registrationCopy";

// Logo, kicker and event title rendered in the PublicShell header slot.
export const RegistrationBrandLockup: FC<{eventName: string; logoUrl?: string}> = ({eventName, logoUrl}) => {
    const {labels} = useRegistrationCopy();

    return (
        <div className="public-registration-brand-lockup">
            {logoUrl ? (
                <img
                    className="public-registration-logo"
                    src={logoUrl}
                    alt={eventName}
                />
            ) : null}
            <Typography.Text className="public-registration-kicker">{labels.pageTitle}</Typography.Text>
            <Typography.Title level={1}>{eventName}</Typography.Title>
        </div>
    );
};

export const EventBand: FC<{dateRange: string; place?: string}> = ({dateRange, place}) => {
    const {labels} = useRegistrationCopy();

    return (
        <section className="public-registration-event-band">
            <div className="public-registration-fact">
                <CalendarOutlined aria-hidden/>
                <div>
                    <Typography.Text>{labels.eventDates}</Typography.Text>
                    <Typography.Title level={2}>{dateRange}</Typography.Title>
                </div>
            </div>

            {place ? (
                <div className="public-registration-fact">
                    <EnvironmentOutlined aria-hidden/>
                    <div>
                        <Typography.Text>{labels.eventPlace}</Typography.Text>
                        <Typography.Title level={2}>{place}</Typography.Title>
                    </div>
                </div>
            ) : null}
        </section>
    );
};
